import { render, staticRenderFns } from "./BrandBin.vue?vue&type=template&id=151db4ac&scoped=true"
import script from "./BrandBin.vue?vue&type=script&lang=js"
export * from "./BrandBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151db4ac",
  null
  
)

export default component.exports